import React, { useState, useEffect, useMemo } from 'react';
import { getDatabase, ref, query, orderByChild, equalTo, onValue } from 'firebase/database';
import './Messaging.css';

const Inbox = ({ user, onMessageSelect }) => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [filter, setFilter] = useState('all'); // 'all', 'read', 'unread'
    const db = getDatabase();

    useEffect(() => {
        if (user) {
            const messagesRef = query(ref(db, 'messages'), orderByChild('to'), equalTo(user.email));
            const unsubscribe = onValue(messagesRef, (snapshot) => {
                const fetchedMessages = [];
                snapshot.forEach((childSnapshot) => {
                    fetchedMessages.push({
                        id: childSnapshot.key,
                        ...childSnapshot.val(),
                    });
                });
                setMessages(fetchedMessages.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)));
                setLoading(false);
            });

            return () => unsubscribe();
        }
    }, [user, db]);

    const filteredMessages = useMemo(() => {
        return messages
            .filter(msg => {
                if (filter === 'read') return msg.isRead;
                if (filter === 'unread') return !msg.isRead;
                return true;
            })
            .filter(msg => {
                if (!searchTerm) return true;
                const searchLower = searchTerm.toLowerCase();
                return (
                    (msg.fromName && msg.fromName.toLowerCase().includes(searchLower)) ||
                    (msg.subject && msg.subject.toLowerCase().includes(searchLower)) ||
                    (msg.body && msg.body.toLowerCase().includes(searchLower))
                );
            });
    }, [messages, searchTerm, filter]);

    if (loading) {
        return <div className="email-list"><p>Loading messages...</p></div>;
    }

    return (
        <>
            <div className="email-list-toolbar">
                <div className="search-container inbox-search">
                     <span className="material-icons search-icon">search</span>
                    <input 
                        type="text"
                        placeholder="Search mail"
                        className="search-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className="inbox-filter">
                    <select value={filter} onChange={(e) => setFilter(e.target.value)}>
                        <option value="all">All</option>
                        <option value="read">Read</option>
                        <option value="unread">Unread</option>
                    </select>
                </div>
            </div>
            <div className="email-list">
                {filteredMessages.length === 0 ? (
                    <p className="no-messages">No messages match your criteria.</p>
                ) : (
                    filteredMessages.map((msg) => (
                        <div key={msg.id} className={`email-item ${!msg.isRead ? 'unread' : ''}`} onClick={() => onMessageSelect(msg.id)}>
                            <div className="email-checkbox">
                                <input type="checkbox" onClick={(e) => e.stopPropagation()} />
                            </div>
                            <span className="material-icons email-star" onClick={(e) => e.stopPropagation()}>star_border</span>
                            <div className="email-sender">{msg.fromName || msg.from}</div>
                            <div className="email-content">
                                <div className="email-subject">{msg.subject}</div>
                                <div className="email-preview">- {msg.body.substring(0, 50)}...</div>
                            </div>
                            <div className="email-date">{new Date(msg.timestamp).toLocaleDateString()}</div>
                        </div>
                    ))
                )}
            </div>
        </>
    );
};

export default Inbox;
